import { Coffee, Sandwich, Croissant } from "lucide-react";
import { SITE } from "@/lib/site";

const SERVICES = [
  {
    icon: Coffee,
    title: "Espresso Bar & Coffee Cart",
    image: SITE.images.espresso,
    desc: "A fully staffed espresso bar pouring gourmet beverages from our exclusive, hand-selected Monorail beans — lattes, cappuccinos, cortados, mochas, signature drinks, and more, hot or iced. Dairy-free alternatives always available.",
    span: "md:col-span-7",
  },
  {
    icon: Sandwich,
    title: "Italian-Style Paninis",
    image: SITE.images.panini,
    desc: "Authentic grilled paninis pressed to perfection with fresh ingredients — a savory, satisfying complement to any event menu.",
    span: "md:col-span-5",
  },
  {
    icon: Croissant,
    title: "Gourmet Baked Goods",
    image: SITE.images.baked,
    desc: "An irresistible selection of pastries and sweet treats baked with the finest ingredients. Custom cakes available for special occasions.",
    span: "md:col-span-12",
  },
];

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <p className="uppercase tracking-[0.2em] text-xs font-semibold text-[#8B5E3C] mb-4">
            What We Bring
          </p>
          <h2 className="font-serif-display text-4xl md:text-5xl font-semibold text-[#2C2621] tracking-tight">
            The full Kingston experience, on wheels
          </h2>
          <p className="mt-5 text-[#594D42] text-lg leading-relaxed">
            Every service is crafted on-site by our baristas and team — setup, service,
            and cleanup all included.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${s.title.toLowerCase().split(" ")[0]}`}
                className={`group relative overflow-hidden rounded-lg bg-white border border-[#E5DFD3] shadow-sm transition-all duration-300 hover:shadow-lg hover:border-[#8B5E3C]/30 ${s.span}`}
              >
                <div className="relative h-56 md:h-64 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-8 md:p-10">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="flex items-center justify-center w-11 h-11 rounded-full bg-[#F2EBE1] text-[#8B5E3C]">
                      <Icon size={22} strokeWidth={1.5} />
                    </span>
                    <h3 className="font-serif-display text-2xl md:text-3xl font-semibold text-[#2C2621]">
                      {s.title}
                    </h3>
                  </div>
                  <p className="text-[#594D42] leading-relaxed max-w-2xl">{s.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
